var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16528_1231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0043 10.1548C13.786 10.1548 15.2303 8.67827 15.2303 6.85684C15.2303 5.0354 13.786 3.55884 12.0043 3.55884C10.2226 3.55884 8.77832 5.0354 8.77832 6.85684C8.77832 8.67827 10.2226 10.1548 12.0043 10.1548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6 10.1548C19.7482 10.1548 20.679 9.22403 20.679 8.07583C20.679 6.92763 19.7482 5.99683 18.6 5.99683C17.4518 5.99683 16.521 6.92763 16.521 8.07583C16.521 9.22403 17.4518 10.1548 18.6 10.1548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40908 10.1548C6.55728 10.1548 7.48808 9.22403 7.48808 8.07583C7.48808 6.92763 6.55728 5.99683 5.40908 5.99683C4.26088 5.99683 3.33008 6.92763 3.33008 8.07583C3.33008 9.22403 4.26088 10.1548 5.40908 10.1548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39717 12.0008C6.67365 11.4837 5.77469 11.2745 4.89717 11.4188C4.21812 11.4162 3.56582 11.6833 3.08369 12.1615C2.60156 12.6397 2.32908 13.2898 2.32617 13.9688V18.0958C2.32697 18.3899 2.4444 18.6716 2.6527 18.8792C2.86099 19.0867 3.14313 19.2031 3.43717 19.2028C6.08317 19.2028 5.76417 19.2508 5.76417 19.0888C5.76517 16.1648 5.41817 14.0198 7.39717 12.0008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.899 11.4338C12.1461 11.3006 11.3738 11.3228 10.6297 11.4988C9.88564 11.6749 9.1854 12.0013 8.57202 12.4578C6.49902 14.1178 6.89801 16.3578 6.89801 19.0888C6.8988 19.4395 7.03845 19.7755 7.28639 20.0235C7.53433 20.2714 7.87038 20.411 8.22102 20.4118C16.197 20.4118 16.515 20.6688 16.988 19.6218C17.143 19.2678 17.101 19.3798 17.101 15.9918C17.0992 14.8438 16.6663 13.7382 15.8881 12.8941C15.11 12.05 14.0432 11.5288 12.899 11.4338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1069 11.4189C18.2294 11.2741 17.3303 11.4834 16.6069 12.0009C18.5709 14.0009 18.2389 16.0008 18.2389 19.0898C18.2389 19.2528 17.9739 19.2038 20.5269 19.2038C20.8314 19.2041 21.1236 19.0836 21.3393 18.8688C21.5551 18.654 21.6769 18.3623 21.6779 18.0578V13.9709C21.6767 13.6345 21.6093 13.3016 21.4795 12.9912C21.3496 12.6809 21.1599 12.3992 20.9211 12.1622C20.6824 11.9252 20.3993 11.7376 20.088 11.6101C19.7767 11.4825 19.4433 11.4175 19.1069 11.4189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16528_1231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame9);
export default __webpack_public_path__ + "static/media/Frame (9).13349302.svg";
export { ForwardRef as ReactComponent };